
import { defineComponent } from "vue";
import RecordsSummary from "@/components/accumulations/RecordsSummary.vue";
import Spinner from "@/components/shared/Spinner.vue";
import { snakeCase } from "lodash-es";
import {
  useDataSource,
  useGammaData,
  useLoading,
  useMap,
  useOrgSettings,
} from "@/services";
import { DatasetRecord } from "@/types";
import { mapState } from "pinia";

export default defineComponent({
  name: "AccumulationsTabs",
  components: {
    RecordsSummary,
    // eslint-disable-next-line no-undef
    Spinner,
  },
  data: () => ({
    tabIndex: 0,
  }),
  computed: {
    ...mapState(useMap, ["dataBoundary"]),
    accumulations(): Record<string, any> {
      return useGammaData().accumulations;
    },
    hasStickyTable(): boolean {
      return [1, 3].includes(this.tabIndex) && !!this.dataBoundary;
    },
    isLoadingData(): boolean {
      return useLoading().isLoadingData("accumulations");
    },
    claims(): DatasetRecord[] {
      return useGammaData().claims;
    },
    policies(): DatasetRecord[] {
      return useGammaData().policies;
    },
    showAccumulation(): boolean {
      const hasDataFilter = useGammaData().dataSources.some(
        (x) => useDataSource(x)().userFilters.length
      );
      return (!!this.dataBoundary || hasDataFilter) && !this.isLoadingData;
    },
  },
  methods: {
    initDrawMode() {
      useMap().setEditingMode({ mode: "draw_circle" });
    },
    getRecordTypes(type: string): string[] {
      return (
        useOrgSettings()
          .accumulations?.accumulationsLookups.filter(
            (l) => l.dataSetType === type
          )
          .map((l) => snakeCase(l.businessLine + l.dataSetType)) || []
      );
    },
  },
});
